import { useState } from 'react';
import type { FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

const hotKeywords = ['星际远征', '江湖笔录', '悬疑', '科幻', '2026新剧', '高分电影'];

export default function HomeSearch() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState('');

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : '/search');
  };

  return (
    <section className="px-4 md:px-6 lg:px-10 -mt-10 md:-mt-16 relative z-30">
      <div className="rounded-lg bg-background-100 border border-background-300/60 p-4 md:p-6">
        <form onSubmit={submit} className="flex flex-col sm:flex-row items-stretch gap-3">
          <div className="relative flex-1">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-500" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入影视名称、类型或关键词，如“星际远征”“悬疑”"
              className="w-full h-12 pl-11 pr-4 rounded-md bg-background-200 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none focus:border-primary-400 transition-colors"
            />
          </div>
          <button
            type="submit"
            className="h-12 px-8 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-search-2-line mr-1.5" />
            全网搜索
          </button>
        </form>
        <div className="mt-4 flex flex-wrap items-center gap-2 text-xs">
          <span className="text-foreground-500">热门搜索：</span>
          {hotKeywords.map((k) => (
            <button
              key={k}
              type="button"
              onClick={() => navigate(`/search?q=${encodeURIComponent(k)}`)}
              className="px-3 py-1 rounded-full bg-secondary-100/70 text-secondary-900 hover:bg-primary-500/20 hover:text-primary-300 transition-colors cursor-pointer"
            >
              {k}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}